import * as Yup from 'yup';
import { FILING_STATUS, SOCIAL_SECURITY_START_AGE, SPOUSE_SOCIAL_SECURITY_START_AGE } from '../../../constants';

const ThirdStepSchemaValidator = () => Yup.object().shape({
  benefitEstimator: Yup.object().shape({
    spouseSocialSecurityStartAge: Yup.number()
      .when('filingStatus', {
        is: (filingStatus) => filingStatus === FILING_STATUS.JOINT,
        then: () => Yup.number()
          .min(SPOUSE_SOCIAL_SECURITY_START_AGE.MIN, `Select a start spouse age from ${SPOUSE_SOCIAL_SECURITY_START_AGE.MIN} to ${SPOUSE_SOCIAL_SECURITY_START_AGE.MAX} years old`)
          .max(SPOUSE_SOCIAL_SECURITY_START_AGE.MAX, `Select a start spouse age from ${SPOUSE_SOCIAL_SECURITY_START_AGE.MIN} to ${SPOUSE_SOCIAL_SECURITY_START_AGE.MAX} years old`)
          .required('This field is required'),
      }),
    socialSecurityStartAge: Yup.number()
      .min(SOCIAL_SECURITY_START_AGE.MIN, `Select a start age from ${SPOUSE_SOCIAL_SECURITY_START_AGE.MIN} to ${SPOUSE_SOCIAL_SECURITY_START_AGE.MAX} years old`)
      .max(SOCIAL_SECURITY_START_AGE.MAX, `Select a start age from ${SPOUSE_SOCIAL_SECURITY_START_AGE.MIN} to ${SPOUSE_SOCIAL_SECURITY_START_AGE.MAX} years old`)
      .required('This field is required'),
  }),
});

export default ThirdStepSchemaValidator;
